export default __webpack_public_path__ + "static/media/cart-icon.5438a5d5.svg";